import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loader/loader.service';

@Injectable()
export class LoadInterceptor implements HttpInterceptor {
  constructor(private loadService: LoadingService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const notInPage = !request.urlWithParams.includes('inPage=true');
    if(notInPage){
      this.loadService.showLoading();
    };
    return next.handle(request).pipe(
      finalize(()=>{
        if(notInPage){
          this.loadService.hideLoading();
        }
      })
    );
  }
}
